import { useMutation, useQueryClient } from 'react-query';
import request from '../../../../../helpers/request';
import { queryKeysShutdowns } from '../../constants/queryKeys';

const onDeleteFilter = async (id) => {
  return await request.delete(
    `/Filter?id=${id}`,
    null,
    'При удалении фильтра произошла ошибка',
    'Error'
  );
};

const useDeleteFilter = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(onDeleteFilter, {
    onSuccess: (data) => {
      if (data === 'Error') return;

      if (data.success) {
        queryClient.invalidateQueries(queryKeysShutdowns.savedFilters());
      }
    },
  });

  return {
    isDeleteFilterLoading: mutation.isLoading,
    onDeleteFilter: mutation.mutateAsync,
  };
};

export default useDeleteFilter;
